import { useQuery, } from 'react-query';

import { type IUser } from 'src/api/users-api';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api';

type GetTeamMembersResponse = {
    members: IUser[];
};

/**
 * Leads are guaranteed to be sorted by `inserted_at` in descending order.
 */
export const useTeamMembers = () => {
    return useQuery(
        [queryKeys.teamMembers],
        async () => {
            const res = await apiClient('api/landlord/team/members').json<GetTeamMembersResponse>();
            return res.members;
        },
    );
};

export default useTeamMembers;